const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function rowsToCsv(headers, rows) {
  return [headers.map(escapeCell).join(','), ...rows.map((row) => row.map(escapeCell).join(','))].join('\n');
}

export function downloadCsv(content, filename) {
  const blob = new Blob([`\ufeff${content}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Export objects to CSV using a column map: [{ header, value: (row) => any }]
 */
export function exportRowsToCsv(rows, columns, filenamePrefix) {
  const headers = columns.map((column) => column.header);
  const data = rows.map((row) => columns.map((column) => column.value(row)));
  const stamp = new Date().toISOString().split('T')[0];
  downloadCsv(rowsToCsv(headers, data), `${filenamePrefix}_${stamp}.csv`);
  return rows.length;
}
